.divider {
  margin-top: 32px;
  margin-bottom: 32px;
}

.gridContainer {
  min-height: 200px;
}

.notesHeading {
  margin-top: 16px;
}

.noteChip {
  margin: 8px;
}

.altNamesHeading {
  margin-top: 16px;
}

.altNameLink {
  padding-right: 8px;
}
